import dayjs from 'dayjs'
import { LoteApiInputProps, LoteInputProps } from '../../../interfaces/lote.ts'
import { dateToDMYHHMMSS } from '../../../utils/dayjsHelper.ts'

export const loteRegistroComposeService = (input: LoteInputProps): LoteApiInputProps => {
  return {
    // codigoLote: input.codigoLote,
    descripcion: input.descripcion,
    fechaAdmision: dateToDMYHHMMSS(input.fechaAdmision)!,
    fechaFabricacion: dayjs(input.fechaFabricacion).format('DD/MM/YYYY').toString(),
    fechaVencimiento: dayjs(input.fechaVencimiento).format('DD/MM/YYYY').toString(),
    atributo1: input.atributo1,
    atributo2: input.atributo2,
  }
}
